//
//
//
//
//
//
//
//
//

export default {
  name: 'product-card-preview-image',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  props: {
    element: Object,
  },
  computed: {
    imageUrl() {
      return _.get(this.element, 'thumbnails.jpg.url') || 'https://static.moele.me/img/placeholders/placeholder-640x360-light.jpg?w=480';
    },
  },
  methods: {
    previewImgError(event) {
      event.target.src = 'https://static.moele.me/img/me-thumb-placeholder.180718.png';
    },
  },
};
